import './form';

(function (w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({}, w.Completude, {
        tarifs: {
            data: {},
            fromHome : false,         
            $form:null,            
            steps:null,
            gtmPage:'DemandeTarif',
            init: function () {
                                
                Completude.tarifs.$form = Completude.SetFormValidation($('#form-tarifs'));
                
                               

                // Active la gestion des étapes (library Steps.js)
                this.steps = new Steps({
                    steps: '[data-step-index]',
                    progress : '.progress-step',
                    container: document.querySelector('#tarifs-container'),
                    backNavigator : true
                });
                               
                // Sur changement de la classe on charge les matières
                $("#field-class").on('selectric-change',function(ev,el,selectric) {  
                    if (el.value!='') {
                        Completude.tarifs.updateMatieres(el.value);                        
                    }
                });
                
                // Retour à l'étape précédente
                $('[data-move-to="prev"]').on('click', function (event) {
                    event.preventDefault();
                    Completude.tarifs.steps.prev();                  
                });

                // Validation étape 1
                $('.tarif-step1-next').on('click', function (event) {
                    event.preventDefault();
                    Completude.tarifs.processStep1();                    
                });
                // Validation étape 2
                $('.tarif-step2-next').on('click', function (event) {
                    event.preventDefault();
                    Completude.tarifs.processStep2();                    
                });
                // Validation étape 3
                $('.tarif-step3-next').on('click', function (event) {
                    event.preventDefault();
                    Completude.tarifs.processStep3();                    
                });
                
                                            
                Completude.tarifs.prefillForm();
                

                 // Passe directement à la deuxième étape si on vient de la home
                 if (window.sessionStorage.getItem("redirectfromhome")==='true') {
                    window.sessionStorage.removeItem("redirectfromhome");
                    Completude.tarifs.fromHome = true;
                    Completude.tarifs.gtmPage = Completude.tarifs.gtmPage + "_home";
                    // Passe Directement à l'étape suivante si on vien de la home                                                               
                    Completude.tarifs.steps.next();                                
                    w.Completude.TagManager(Completude.tarifs.gtmPage,'ChoixMatiere');
                    w.Completude.TagManagerTunnel();

                    document.querySelector('body').scrollIntoView();
                } else {
                    Completude.TagManager(this.gtmPage,'ChoixClasse'); 
                    Completude.TagManagerTunnel(); 
                }
                              
            },                                                    

            /**
             * 
             * @returns Init du formualire si un devis a déjà été fait
             */
            prefillForm: function () {
                
                let oldValues = Completude.GetStorage("form-demande-tarifs");
                
                if (typeof(oldValues)!=='undefined' && oldValues!==null) {
                    try {
                        let data = oldValues;
                        $('#field-class').val(data.IdClasse).selectric('refresh');                           
                        Completude.tarifs.updateMatieres(data.IdClasse, data.IdMatiere);
                        $("#field-address").SetLocalisation(data.localisation);                    
                        $('#field-lastname').val(data.Nom).focusout();
                        $('#field-phone') .val(data.Telephone).focusout();
                        $('#field-email').val(data.Email).focusout();
                        if (data.Sexe!==undefined) {
                            if (data.Sexe==="1") {                                
                                $("#field-civilite-homme").prop("checked", true);
                            }
                            if (data.Sexe==="2") {                                
                                $("#field-civilite-femme").prop("checked", true);
                            }
                        }                       
                    }
                    catch (e) {
                        console.info('Erreur in form-tarif.prefillForm()');
                    }                    
                }            
                
            },
            
            /**
             * Validation adresse & classe
             * @returns Validation de l'étape 1
             */
            processStep1: function () {
                if (!Completude.tarifs.$form.validate({group:'tarif_step1'})) {
                    return;
                }
                let self = this;
                //On regarde si l'adresse est déservie.
                jQuery("#etape1>div:first-child").loading(
                    jQuery.ajax({
                        url: disko_ajax_object.ajaxurl,
                        type: 'post',
                        data: {
                            'action'    : 'wp_est_desservie',
                            'Latitude'       : window.autocomplete.localisation.lat,
                            'Longitude'       : window.autocomplete.localisation.lng,
                            'Ville'      : window.autocomplete.localisation.city                            
                        },
                        success: function (response) {
                            if (response.success && response.data==='true') {
                                // Passe à l'étape suivante                       
                                Completude.tarifs.steps.next();                                
                                w.Completude.TagManager(Completude.tarifs.gtmPage,'ChoixMatiere');                                
                                w.Completude.TagManagerTunnel();
                                document.querySelector('body').scrollIntoView()
                            } 
                            else {                                                                                                
                                // Adresse non désservie
                                jQuery('#popup-error1-link').click();
                                Completude.TagManagerTunnel('demandetarif/step-0',{'event' : 'GTMerror' , 'ErrorType': "Adresse non désservie"});                                                               
                            }
                        }
                    }).promise()
                );

            },

            /**
             * Validation de l'étape 2             
             */
            processStep2: function () {
                if (!Completude.tarifs.$form.validate({group:'tarif_step2'})) {
                    return;
                }
                                                               
                jQuery("#etape2>div:first-child").loading(
                    jQuery.ajax({
                        url: disko_ajax_object.ajaxurl,
                        type: 'post',
                        data: {
                            'action'             : 'wp_nb_prof_dispo',
                            'IdMatiere'      : $('#etape2 .active-el').data('matiere-id'),
                            'Matiere': $('#etape2 .active-el').html(),
                            'IdClasse'        : $('#field-class').val(),                             
                            'Latitude'      : autocomplete.localisation.lat,
                            'Longitude'      : autocomplete.localisation.lng,
                        },
                        success: function (response) {
                            // Réactiver les 3 lignes ci dessous pour afficher le nombre de prof dans le périmètre
                            if(response !== "") {                                                                
                               $('.locations-message').html(response).parent().removeClass('hide');
                            }
                            //$('.locations-message').html("<h6>Vous êtes à 1 clic de savoir combien vous coûte 1h de cours particulier avec <strong>le crédit d'impôt immédiat de 50 %</strong> !</h6>").parent().removeClass('hide')

                            $('#courseLabel').val( $('#field-class option:selected').html() );
                            
                            // Passe à l'étape suivante
                            //window.history.pushState("", "", '/demande-de-tarifs/#2');                                                    
                            
                            // Passe à l'étape suivante                       
                            Completude.tarifs.steps.next();                           
                            w.Completude.TagManager(Completude.tarifs.gtmPage,'Coordonnees');
                            w.Completude.TagManagerTunnel();
                            document.querySelector('body').scrollIntoView()
                        }
                    }).promise()
                );
            },
            
            /**
             * Mise à jour de la liste des matières
             * @param {id de la classe} classId 
             */
            updateMatieres: function (classId,IdMatiere) {
                Completude.GetMatieres(classId).then(function(response) {
                    if ( true    == response.success) {
                        var matieres = response.data;
                        $("#matieres-principales").empty();
                        $("#matieres-secondaires").empty();
                        jQuery('.accordion-expander').addClass('hide');
                        jQuery.each(matieres, function (i, matiere) {
                            if (matiere.MatierePrioritaire===true) {
                                $("#matieres-principales")
                                    .append(
                                        jQuery('<li></li>')
                                        .html(jQuery('<a></a>')
                                        .addClass('btn btn--white-gradient')
                                        .text(matiere.Libelle)
                                        .attr('data-matiere-id', matiere.Id)                                    
                                    )
                                );
                            }
                            if (matiere.MatierePrioritaire===false) {
                                jQuery('.accordion-expander').removeClass('hide');                                                                
                                $("#matieres-secondaires")
                                    .append(
                                        jQuery('<li></li>')
                                        .html(jQuery('<a></a>')
                                        .addClass('btn btn--white-gradient')
                                        .text(matiere.Libelle)
                                        .attr('data-matiere-id', matiere.Id)
                                    )
                                );                                                                    
                            }
                        });

                        // Matière par défaut
                        if( typeof(IdMatiere) !== 'undefined' && IdMatiere!==null  ) {  
                            $('#matiereInput').val(IdMatiere).focusout();                  
                            $('[data-matiere-id='+ IdMatiere +']').addClass('active-el');
                        }
                                                
                        Completude.tarifs.MatiereClicked();
                    }                         
                });                
            },
                                    
            /**
             * Choix d'une matiere
             */
            MatiereClicked: function() {
                                
                $('#etape2 a[data-matiere-id]').on('click', function(event) {
                    $(this).closest('.form__step-content').find('.list-btns a').removeClass('active-el');
                    $(this).addClass('active-el'); 
                    $('#matiereInput').val( $(this).data('matiere-id') );                   
                    Completude.tarifs.processStep2();
                });
            },
            
             /**
             * Validation de l'étape 3 (Clic sur voir mon Tarif)
             */
            processStep3: function () {
                if (!Completude.tarifs.$form.validate({group:'tarif_step3'})) {
                    return;
                }
                
                let el = document.getElementById('field-class');                

                var postData = Object.assign({
                    'action': 'wp_demande_tarifs',
                    'Latitude': window.autocomplete.localisation.lat,
                    'Longitude': window.autocomplete.localisation.lng,
                    'Ville': window.autocomplete.localisation.city,
                    'CodePostal': window.autocomplete.localisation.postalCode,
                    'Adresse': window.autocomplete.localisation.address,                    
                    'Telephone' : $('#field-phone').val(),
                    'Email' : $('#field-email').val(),
                    'AccordEMail' : $('#field-info').prop("checked"),
                    'Nom' : $('#field-lastname').val(),                  
                    'IdClasse' : $('#field-class').val(), 
                    'Classe' : el.options[el.selectedIndex].innerHTML, 
                    'IdMatiere' : $('#etape2 .active-el').data('matiere-id'),                                   
                    'Sexe' :  $("[name='civilite']:checked").val(),
                    'Url' : document.location.href
                  }, Completude.GetGlobalUtmFields());

                
                jQuery("#etape3>div:first-child").loading(
                    jQuery.ajax({
                        url: disko_ajax_object.ajaxurl,                        
                        type    : 'post',
                        data    : postData,
                        dataType: 'json',
                        cache   : false,
                        success : function (response) {
                            
                            if (response.success) {
                                                                
                                // Sauvegarde du résultat dans les données utilisateur
                                Completude.SetStorage('form-demande-tarifs-niveau-' + response.data.demandeTarifs.Niveau, response.data,7);
                                // Sauvegarde des paramètres du formulaire
                                Completude.SetStorage('form-demande-tarifs',   Object.assign(postData,{ 'localisation' : autocomplete.localisation}));                                                            
                                w.Completude.agence = response.data.agence;
                                w.Completude.UpdateAgence(response.data.agence.Id);
                                    
                                $("#rate-details").html(response.data.tpl);
                                jQuery('.progress-steps').hide()                                                                                            
                                // Passe à l'étape suivante                       
                                Completude.tarifs.steps.next();                                
                                w.Completude.TagManager(Completude.tarifs.gtmPage,'Confirmation');
                                w.Completude.TagManagerTunnel(); // Fin du tunnel Tarif
                                w.Completude.TagManagerTunnel("demandeProf/step-1"); // Debut du tunnel Demande de prof
                                document.querySelector('body').scrollIntoView()
                            }
                            return false;
                        }
                    }).promise()
                );
            }
        }
    })
})(window);


jQuery(function () {
    if (jQuery("#section-tarifs").length > 0) {
        window.Completude.tarifs.init();
    }
});